import { makeApiCall } from "../apiRequest";
import { setAuthItem } from "@/utils/authStorage";

export default {
  state: {
    adminData: [],
    organizationId: null,
    roomround_access_token: null,
    loginInformation: null,
  },
  getters: {
    getAdminData: (state) => state.adminData,
    getOrganizationId: (state) => state.organizationId,
    getRoomRoundAccessToken: (state) => state.roomround_access_token,
    getLoginInformation: (state) => state.loginInformation,
  },
  actions: {
    storeUserData({ commit }, payload) {
      commit("setOrganizationId", payload.organizationId);
      commit("setRoomRoundAccessToken", payload.token);
      commit("setRoomRoundLoginUserInformation", payload);
    },
    async userLogin({ commit }, payload) {
      const response = await makeApiCall("auth/login", "POST", payload);
      if (response.data.data) {
        const token = response.data.data.token;
        setAuthItem("roomround_access_token", token);
        setAuthItem("user_id", response?.data?.data.userId);
        
      } else {
        return response;
      }
      return response;
    },
    async getAdminData({ commit }, id) {
      let url = `auth/loginAsAdmin?organizationId=${id}`;
      const response = await makeApiCall(url, "GET");
      if (!response.error) {
        commit("setAdminData", response.data);
      }
      return response;
    },
    async updateUser({ commit }, payload) {
      let url = `settings/updateMap`;
      const response = await makeApiCall(url, "POST", payload);
      return response.data;
    },
    async confirmEmail({ commit }, payload) {
      const ForgotPasswordURL = `auth/forgetPassword?email=${encodeURIComponent(
        payload.email
      )}`;
      const response = await makeApiCall(ForgotPasswordURL, "POST", payload);
      return response.data;
    },

    async resetPassword({ commit }, payload) {
      const url = `auth/changePassword`;
      const response = await makeApiCall(url, "POST", payload);
      return response.data;
    },
  },
  mutations: {
    setAdminData: (state, payload) => (state.adminData = payload),
    setOrganizationId(state, organizationId) {
      state.organizationId = organizationId;
    },
    setRoomRoundAccessToken(state, token) {
      state.roomround_access_token = token;
    },
    setRoomRoundLoginUserInformation(state, payload) {
      state.loginInformation = payload;
    },
  },
};
